import React from 'react';

const Spinner = () => (
  <svg className="animate-spin h-5 w-5 text-white mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
  </svg>
);

// `packages` come from /api/packages (editable in the admin panel).
const PaymentPopup = ({ closePaymentPopup, purchaseLookups, loading, packages }) => {
  const isAnyLoading = Object.values(loading).some(value => value);

  return (
    <div className="fixed inset-0 flex justify-center bg-black bg-opacity-75 z-50 animate-fadeIn overflow-y-auto">
      <div className="bg-white text-black p-8 rounded-lg shadow-lg w-full max-w-3xl relative border border-gray-300 overflow-y-auto m-4">
        <button
          className="absolute top-4 right-4 text-black text-2xl"
          onClick={closePaymentPopup}
        >
          &times;
        </button>

        <div className="mt-8 text-center bg-[#4c84ff] text-white p-4 rounded-lg mb-6">
          <h3 className="text-xl font-semibold mb-4">Are you looking for an Individual or Company subscription plan with UNLIMITED Lookups?</h3>
          <p className="mb-6">FreightValidate.Com may be what you are looking for. <a href="https://www.freightvalidate.com" className="text-white font-bold underline">Click Here</a> to be connected</p>
          <img src="/fv-logo.png" alt="FreightValidate Logo" className="mx-auto w-32" />
        </div>

        <h2 className="text-3xl font-bold mb-6 text-center">On-Demand Pricing</h2>

        {packages.length === 0 && (
          <p className="text-center text-gray-600">No packages are available right now. Please check back soon.</p>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {packages.map((pkg) => (
            <div key={pkg.key} className="p-6 border border-gray-300 rounded-lg shadow hover:shadow-lg transition duration-200 flex flex-col items-center">
              <h3 className="text-2xl font-semibold mb-2 text-[#4c84ff]">{pkg.name}</h3>
              <p className="text-4xl font-bold mb-4">{pkg.displayPrice}</p>
              <p className="text-gray-600 mb-6 text-center">{pkg.description}</p>
              <button
                className="w-full bg-[#4c84ff] text-white py-3 rounded-lg hover:bg-[#3a6cd4] transition duration-200"
                onClick={() => purchaseLookups(pkg.key)}
                disabled={isAnyLoading}
              >
                {loading[pkg.key] ? <Spinner /> : 'Purchase'}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PaymentPopup;
